<template>
  <div class="bar_view">
    <ul>
      <li
        v-for="(item, index) in barList"
        :key="index"
        :class="active == index ? 'blue' : ''"
      >
        <span>{{ index + 1 }}、</span>
        <p>
          {{ item.lable }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  props: ["barList", "active"],
};
</script>

<style lang="scss" scoped>
.bar_view {
  width: 100%;
  ul {
    width: 100%;
    display: flex;
    align-items: center;
    li {
      flex: 1;
      height: 57px;
      background: #f5f6f7;
      border: 1px solid #ffffff;
      border-radius: 0px;
      display: flex;
      align-items: center;
      padding-left: 30px;
      font-weight: bolder;
      span {
        margin-right: 12px;
      }
    }
  }
}
.blue {
  background: #b6dfff !important;
}
</style>
